<div class="form-group">
  <div
    #contentRef
    [ngClass]="getContentValidityClass()"
    class="field-content-projection">
    <ng-content></ng-content>
  </div>

  <!-- Inputs -->
  @switch (fieldType) {
    <!-- Choice Field -->
    @case (FieldType.choice) {
      <div>
        @if (!hideLabel) {
          <label
            class="form-label"
            [attr.for]="inputId">
            {{ getLabel() }}
          </label>
        }
        <ng-select
          [ngClass]="validityClass"
          [items]="fieldOption.choices!"
          [readonly]="readonly"
          bindValue="value"
          bindLabel="display_name"
          placeholder="{{ placeholder ?? getPlaceholder() }}"
          [formControl]="fieldControl"
          [labelForId]="inputId">
        </ng-select>
        <bo-form-field-errors></bo-form-field-errors>
      </div>
    }
    <!-- Checkbox -->
    @case (FieldType.checkbox) {
      <div class="form-group form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [formControl]="fieldControl"
          [ngClass]="validityClass"
          [attr.id]="inputId" />
        <label
          class="form-check-label"
          [attr.for]="inputId">
          @if (!labelTemplate) {
            <span>{{ getLabel() }}</span>
          }
          <ng-container *ngTemplateOutlet="labelTemplate ?? null"></ng-container>
        </label>
        <!-- Error feedback -->
        <bo-form-field-errors></bo-form-field-errors>
      </div>
    }
    <!-- Recaptcha -->
    @case (FieldType.recaptcha) {
      <div class="recaptcha">
        <re-captcha
          [formControl]="fieldControl"
          #captchaRef="reCaptcha"></re-captcha>
        <!-- Error feedback -->
        <!-- Hidden input to make field errors works -->
        <input
          class="form-control"
          type="hidden"
          [ngClass]="validityClass"
          [formControl]="fieldControl"
          [attr.id]="inputId" />
        <!-- Error feedback -->
        <bo-form-field-errors></bo-form-field-errors>
      </div>
    }
    <!-- Phone Number-->
    @case (FieldType.phoneNumber) {
      <div>
        @if (!hideLabel) {
          <label
            class="form-label"
            [attr.for]="inputId">
            {{ getLabel() }}
          </label>
        }
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              id="basic-addon1">
              <i class="pays-icon ic-south-africa"></i>
              +27
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            aria-describedby="basic-addon1"
            [attr.type]="type ? type : (fieldOption.inputType?.toString() ?? 'text')"
            [formControl]="fieldControl"
            [appInputFunction]="inputFunction"
            placeholder="{{ placeholder ?? getPlaceholder() }}"
            [attr.id]="inputId"
            [ngClass]="validityClass" />
          <!-- Error feedback -->
          <bo-form-field-errors></bo-form-field-errors>
        </div>
      </div>
    }
    <!-- Date -->
    @case (FieldType.date) {
      <div class="date-picker-field">
        @if (!hideLabel) {
          <label
            class="form-label"
            [attr.for]="inputId">
            {{ getLabel() }}
          </label>
        }
        <div
          class="input-group flex-nowrap"
          [ngClass]="validityClass">
          <input
            type="text"
            class="form-control"
            ngbDatepicker
            #dp="ngbDatepicker"
            (click)="dp.toggle()"
            navigation="select"
            outsideDays="hidden"
            [autoClose]="'outside'"
            placeholder="{{ placeholder ?? getPlaceholder() }}"
            [ngClass]="validityClass"
            [formControl]="fieldControl"
            [attr.id]="inputId"
            [dayTemplate]="t"
            [readonly]="readonly" />
          <ng-template
            #t
            let-date
            let-focused="focused">
            <div
              class="custom-day"
              [class.focused]="focused">
              {{ date.day }}
            </div>
          </ng-template>
          <button
            type="button"
            class="input-group-text btn-reset w-auto"
            [ngClass]="validityClass"
            (click)="dp.toggle()">
            <i class="iconoir-calendar"></i>
          </button>
        </div>
        <!-- Error feedback -->
        <bo-form-field-errors></bo-form-field-errors>
      </div>
    }
    <!-- Standard Input Field -->
    @default {
      <div>
        @if (!hideLabel) {
          <label
            class="form-label"
            [ngClass]="labelClass"
            [attr.for]="inputId">
            {{ getLabel() }}
          </label>
        }
        <ng-template #input>
          @if (!textArea && !currencyMaskOptions) {
            <input
              #inputElement
              class="form-control"
              [attr.name]="boFieldPath"
              [autocomplete]="autocomplete"
              placeholder="{{ placeholder ?? getPlaceholder() }}"
              [attr.type]="fieldType"
              [formControl]="fieldControl"
              [ngClass]="validityClass + ' ' + inputClass"
              [attr.id]="inputId"
              [appInputFunction]="inputFunction"
              [readonly]="readonly"
              (input)="onInput()" />
          }
          <!-- Unfortunately unable to HostBind on dynamically added elements so have to duplicate the code in order to add
          the currencyMask directive to the input -->
          @if (!textArea && addCurrencyMask) {
            <input
              #inputElement
              [attr.name]="boFieldPath"
              [autocomplete]="autocomplete"
              [formControl]="fieldControl"
              class="form-control"
              [ngClass]="validityClass + ' ' + inputClass"
              placeholder="{{ getPlaceholder() }}"
              [attr.id]="inputId"
              (input)="onInput()"
              currencyMask
              [readonly]="readonly"
              [options]="currencyMaskOptions" />
          }
          @if (textArea) {
            <textarea
              [attr.name]="boFieldPath"
              [formControl]="fieldControl"
              class="form-control"
              [ngClass]="validityClass"
              (input)="onInput()"
              placeholder="{{ placeholder ?? getPlaceholder() }}"
              [attr.id]="inputId"
              rows="{{ textArea.rows }}"
              cols="{{ textArea.cols }}">
            </textarea>
          }
        </ng-template>
        <!-- No Input Group -->
        @if (!inputGroupText) {
          <ng-container [ngTemplateOutlet]="input"></ng-container>
        }
        <!-- Error feedback -->
        @if (!inputGroupText) {
          <bo-form-field-errors></bo-form-field-errors>
        }
        <!-- With Input Group -->
        @if (inputGroupText) {
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ inputGroupText }}</span>
            </div>
            <ng-container [ngTemplateOutlet]="input"></ng-container>
            <!-- Error feedback -->
            <bo-form-field-errors></bo-form-field-errors>
          </div>
        }
      </div>
    }
  }
  <!-- Help text only shown when there is no label, if label the help text is displayed with a popover on label. -->
  <bo-help-text-list></bo-help-text-list>
</div>
